export default {
  keys: {
    TABLE_FILTER: {name: 'tableFilter', storage: sessionStorage},
    VISIBLE_COLUMNS: {name: 'visibleColumns', storage: localStorage}
  },

  setItem (key, value) {
    try {
      const {storage, name} = key
      storage.setItem(name, JSON.stringify(value))
    } catch (e) {}
  },

  updateItem (key, value) {
    try {
      const {storage, name} = key
      storage.setItem(name, JSON.stringify(value))
    } catch (e) {}
  },

  getItem (key) {
    if (!key) {
      return null
    }

    try {
      const {storage, name} = key
      const value = storage.getItem(name)

      if (!value) {
        return null
      }

      try {
        return JSON.parse(value)
      } catch (e) {
        return value
      }
    } catch (e) {}
  },

  removeItem (key) {
    try {
      const {storage, name} = key
      storage.removeItem(name)
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// ./src/libs/storage.js